import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface TradeTypeFormFieldProps {
  tradeTypes?: { label: string; value: string }[]
  loading?: boolean
}

export const TradeTypeFormField: React.FC<TradeTypeFormFieldProps> = ({ tradeTypes, loading }) => {
  const { control, setValue } = useFormContext<{ trade_type: string }>()

  return (
    <FormField
      name="trade_type"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Trade Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select a Trade Type'}
              loading={loading}
              value={field.value}
              setValue={(val) => setValue('trade_type', val, { shouldValidate: true })}
              options={tradeTypes?.map(({ label, value }) => ({ label, value: value?.toString() }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
